import { Checkbox, Col, Input, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { FaPlus } from "react-icons/fa6";
import { FiMinusCircle } from "react-icons/fi";

const data = [
    { benefit: "Pick-up and drop-off services" },
    { benefit: "Courtesy car" },
    { benefit: "After hours drop-off/pick-up" },
    { benefit: "Mobile mechanic services" },
    { benefit: "Free wifi and comfortable waiting area" }
];

const CustomBenefits = ({ value, onChange }) => {
    const [selectedBenefits, setSelectedBenefits] = useState([]);
    const [extraSelectedBenefits, setExtraSelectedBenefits] = useState([]);
    const [extraBenefits, setExtraBenefits] = useState('');
    const [error, setError] = useState('');

    // Set initial values on mount or when the 'value' prop changes
    useEffect(() => {
        const predefinedBenefits = data
            .filter((item) => value.includes(item.benefit))
            .map((item) => item.benefit);
        const extraBenefits = value?.filter((benefit) => !predefinedBenefits.includes(benefit));

        if (JSON.stringify(predefinedBenefits) !== JSON.stringify(selectedBenefits)) {
            setSelectedBenefits(predefinedBenefits);
        }
        if (JSON.stringify(extraBenefits) !== JSON.stringify(extraSelectedBenefits)) {
            setExtraSelectedBenefits(extraBenefits);
        }
    }, [value]);

    const checkboxChangeHandler = (item, checked) => {
        let tempArray;
        if (!checked) {
            tempArray = selectedBenefits.filter((benefit) => benefit !== item);
        } else {
            tempArray = [...selectedBenefits, item];
        }
        setSelectedBenefits(tempArray);
        onChange([...tempArray, ...extraSelectedBenefits]);
    };

    const addOtherBenefitHandler = () => {
        if (!extraBenefits) {
            setError('Benefit is required');
        } else {
            const updated = [...extraSelectedBenefits, extraBenefits];
            setExtraSelectedBenefits(updated);
            setExtraBenefits('');
            setError('');
            onChange([...selectedBenefits, ...updated]);
        }
    };

    const removeSelectedBenefitHandler = (index) => {
        const updated = [...extraSelectedBenefits];
        updated.splice(index, 1);
        setExtraSelectedBenefits(updated);
        onChange([...selectedBenefits, ...updated]);
    };

    return (
        <Row className="flex w-full mt-2">
            {data?.map((item, index) => (
                <Col className="mb-2" lg={12} md={12} sm={12} xs={24} key={index}>
                    <Checkbox
                        value={item.benefit}
                        checked={selectedBenefits.includes(item.benefit)}
                        onChange={(e) => checkboxChangeHandler(item.benefit, e.target.checked)}
                        className='benefits-checkboxes'
                    >
                        {item.benefit}
                    </Checkbox>
                </Col>
            ))}
            <Row className="w-full mt-4 flex items-start justify-between gap-4">
                <Col lg={16} md={12} sm={12} xs={13}>
                    <Input
                        className="h-11"
                        style={{ boxShadow: '0px 3px 6px #0000001A' }}
                        placeholder="Enter other benefits"
                        value={extraBenefits}
                        onChange={(e) => setExtraBenefits(e.target.value)}
                    />
                    {error && <p className="text-red-500">{error}</p>}
                </Col>
                <Col lg={7} md={10} sm={10} xs={8}>
                    <div className="flex items-center gap-2 cursor-pointer w-full" onClick={addOtherBenefitHandler}>
                        <div className="p-1 bg-yellow-400 flex items-center justify-center rounded-md">
                            <FaPlus color="white" className="h-3 w-3" />
                        </div>
                        <span>Add More</span>
                    </div>
                </Col>
            </Row>

            <Row className="w-full mt-2">
                {extraSelectedBenefits?.map((benefit, index) => (
                    <Col lg={24} md={14} sm={15} xs={22} className="my-1 flex justify-between items-center" key={index}>
                        <p className=''>{benefit}</p>
                        <FiMinusCircle className="cursor-pointer" onClick={() => removeSelectedBenefitHandler(index)} />
                    </Col>
                ))}
            </Row>
        </Row>
    );
};

export default CustomBenefits;
